module.exports = __webpack_public_path__ + "./fonts/chat-icon.e0d2b7486b532288a980d0cd5d535340.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-window/es/assets/chat-icon.svg
// module id = ./node_modules/react-chat-window/es/assets/chat-icon.svg
// module chunks = 0